import React from 'react'
import {useTranslation} from "react-i18next";

import {
    StyledMainContainer,
    StyledTextContainer,
    StyledTitle,
    StyledDescription,
    StyledImageContainer
} from './PluginsDetailStyle'

const PluginsDetail = ({title, description, img}) => {
    const {t} = useTranslation()
    return (
        <StyledMainContainer>
            <StyledTextContainer>
                <StyledTitle>{t(title)}</StyledTitle>
                <StyledDescription>{t(description)}</StyledDescription>
            </StyledTextContainer>
            <StyledImageContainer>
                <img src={img} alt={''}/>
            </StyledImageContainer>

        </StyledMainContainer>
    )
}

export default PluginsDetail